import ShippingAddressDTO from "@/dto/ShippingAddressDTO";
import platformServer from "../http/platformServer";
import OrderMergeSplitStatus from "@/enum/OrderMergeSplitStatus";

export interface LogisticsAgingPredictOrderParams {
    id: number;
    originalId: string;
    mergeSplitStatus: OrderMergeSplitStatus;
}
export interface LogisticsAgingPredictParams {
    shopId: number;
    shipperAddress: ShippingAddressDTO;
    orders: LogisticsAgingPredictOrderParams[];
}

export interface LogisticsAgingPredictResult {
    orderId: number;

    results: string[];
}
export function getLogisticsAgingPredicts(params: LogisticsAgingPredictParams): Promise<LogisticsAgingPredictResult[]> {
    return platformServer.post(params.shopId, "/logistics_aging_predict/doudian", params);
}
